import { useEffect, useState } from "preact/hooks";
import { Route, Switch, useLocation } from "wouter-preact";
import type { ComponentChildren } from "preact";
import { completeSignIn, signedIn } from "./lib/auth";
import { t, useLang } from "./i18n";
import { DemoWorkbench } from "./pages/Demo";
import { Projects } from "./pages/Projects";
import { ProjectPage } from "./pages/ProjectPage";
import { Operator } from "./pages/Operator";
import { Members } from "./pages/Members";
import { Invite } from "./pages/Invite";
import { Login } from "./pages/Login";
import { Help } from "./help/Help";

function Callback() {
  const [, nav] = useLocation();
  const [err, setErr] = useState("");
  useEffect(() => {
    completeSignIn().then((to) => nav(to, { replace: true })).catch((e) => setErr(String(e)));
  }, []);
  return <Centered>{err || t("common.signingin")}</Centered>;
}

export function Centered({ children }: { children: ComponentChildren }) {
  return <div class="flex h-full items-center justify-center bg-bar p-6 text-center text-muted">{children}</div>;
}

/** Pages that need a signed-in person show the sign-in page instead
 * (GIOTHUB-185) of redirecting to Zitadel at once. */
function SignedIn({ children }: { children: ComponentChildren }) {
  const [ok, setOk] = useState<boolean | null>(null);
  useEffect(() => {
    signedIn().then(setOk).catch(() => setOk(false));
  }, []);
  if (ok === null) return <Centered>{t("common.loading")}</Centered>;
  return ok ? <>{children}</> : <Login />;
}

export function App() {
  useLang(); // the whole tree re-renders when the language changes
  return (
    <Switch>
      <Route path="/callback" component={Callback} />
      <Route path="/demo" component={DemoWorkbench} />
      <Route path="/help">{() => <Help />}</Route>
      <Route path="/help/:slug">{(p: { slug: string }) => <Help slug={p.slug} />}</Route>
      <Route path="/login">{() => <Login returnTo="/" />}</Route>
      <Route path="/invite/:token">{(p: { token: string }) => <Invite token={p.token} />}</Route>
      <Route path="/admin">{() => <SignedIn><Operator /></SignedIn>}</Route>
      <Route path="/members">{() => <SignedIn><Members /></SignedIn>}</Route>
      <Route path="/p/:id">{(p: { id: string }) => <SignedIn><ProjectPage id={p.id} /></SignedIn>}</Route>
      <Route path="/">{() => <SignedIn><Projects /></SignedIn>}</Route>
      <Route><Centered>{t("common.notfound")} <a class="ml-1 text-accent" href="/">{t("nav.projects")}</a></Centered></Route>
    </Switch>
  );
}
